import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { BrowserRouter, Routes } from "react-router-dom";
import { MortgageGuideRoutes } from "GenericMortgageGuides";
import Footer from "./components/FooterNew/index.js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const location = window.location.pathname.toLowerCase();
const baseName = process.env.REACT_APP_BASENAME;

let basePath = baseName;
if (baseName === "/va-loans") {
  basePath = basePath + "/";
}

// console.log("2222" ,basePath)
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App
        location = {location}
        baseName = {baseName}
        basePath = {basePath}
        Footer = {Footer}
      />
    </BrowserRouter>

    {/* <BrowserRouter>
      {location === baseName || location === "/valoans/" ? <App /> : ""}
      {location !== baseName && location !== "/valoans/" ? (
        <MortgageGuideRoutes
          homePath={"/valoans/"}
          showHeader={true}
          showFooter={true}
          FooterComponent={Footer}
        />
      ) : (
        ""
      )}
    </BrowserRouter> */}
  </React.StrictMode>,
  // <React.StrictMode>
  //   <BrowserRouter>
  //   <App />
  //   </BrowserRouter>
  // </React.StrictMode>,
  
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
